import controlPointsService from "../shared/services/controlPointsService";
import { clearCreatePontrolPoint as onClearCreatePontrolPoint } from "./createContolPointActions";

const REQUEST_CONTROL_POINTS = "REQUEST_CONTROL_POINTS";
const RESPONSE_CONTROL_POINTS = "RESPONSE_CONTROL_POINTS";
const REQUEST_CONTROL_POINTS_FAILURE = "REQUEST_CONTROL_POINTS_FAILURE";

const requestControlPointsAction = () => {
  return {
    type: REQUEST_CONTROL_POINTS,
  };
};

const responseControlPointsAction = (data) => {
  return {
    type: RESPONSE_CONTROL_POINTS,
    data,
  };
};

const requestControlPointsFailureAction = (errors) => {
  return {
    type: REQUEST_CONTROL_POINTS_FAILURE,
    errors,
  };
};

const getControlPoints = (options = {}) => {
  return (dispatch) => {
    dispatch(requestControlPointsAction());

    options.orderBy = "title";

    controlPointsService
      .getControlPoints(options)
      .then((result) => {
        dispatch(responseControlPointsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestControlPointsFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_CONTROL_POINT = "REQUEST_CREATE_CONTROL_POINT";
const RESPONSE_CREATE_CONTROL_POINT = "RESPONSE_CREATE_CONTROL_POINT";
const REQUEST_CREATE_CONTROL_POINT_FAILURE = "REQUEST_CREATE_CONTROL_POINT_FAILURE";

const requestCreateControlPointAction = () => {
  return {
    type: REQUEST_CREATE_CONTROL_POINT,
  };
};

const responseCreateControlPointAction = (data) => {
  return {
    type: RESPONSE_CREATE_CONTROL_POINT,
    data,
  };
};

const requestCreateControlPointFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_CONTROL_POINT_FAILURE,
    errors,
  };
};

const createControlPoint = (options) => {
  return (dispatch) => {
    dispatch(requestCreateControlPointAction());

    controlPointsService
      .createControlPoint(options)
      .then((result) => {
        options.id = result.data.id;
        dispatch(onClearCreatePontrolPoint());
        dispatch(responseCreateControlPointAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateControlPointFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_CONTROL_POINT = "REQUEST_DELETE_CONTROL_POINT";
const RESPONSE_DELETE_CONTROL_POINT = "RESPONSE_DELETE_CONTROL_POINT";
const REQUEST_DELETE_CONTROL_POINT_FAILURE = "REQUEST_DELETE_CONTROL_POINT_FAILURE";

const requestDeleteControlPointAction = () => {
  return {
    type: REQUEST_DELETE_CONTROL_POINT,
  };
};

const responseDeleteControlPointAction = (data) => {
  return {
    type: RESPONSE_DELETE_CONTROL_POINT,
    data,
  };
};

const requestDeleteControlPointFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_CONTROL_POINT_FAILURE,
    errors,
  };
};

const deleteControlPoint = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteControlPointAction());

    controlPointsService
      .deleteControlPoint(options)
      .then((result) => {
        dispatch(onClearCreatePontrolPoint());
        dispatch(responseDeleteControlPointAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteControlPointFailureAction(error.response));
      });
  };
};

const ON_SELECT_CONTROL_POINT = "ON_SELECT_CONTROL_POINT";

const onSelectControlPointAction = (data) => {
  return {
    type: ON_SELECT_CONTROL_POINT,
    data,
  };
};

const selectControlPoint = (data) => {
  return (dispatch) => {
    dispatch(onSelectControlPointAction(data));
  };
};

const ON_UNSELECT_CONTROL_POINT = "ON_UNSELECT_CONTROL_POINT";

const onUnselectControlPointAction = () => {
  return {
    type: ON_UNSELECT_CONTROL_POINT,
    data: null,
  };
};

const unselectControlPoint = () => {
  return (dispatch) => {
    dispatch(onClearCreatePontrolPoint());
    dispatch(onUnselectControlPointAction());
  };
};

const REQUEST_UPDATE_CONTROL_POINT = "REQUEST_UPDATE_CONTROL_POINT";
const RESPONSE_UPDATE_CONTROL_POINT = "RESPONSE_UPDATE_CONTROL_POINT";
const REQUEST_UPDATE_CONTROL_POINT_FAILURE = "REQUEST_UPDATE_CONTROL_POINT_FAILURE";

const requestUpdateControlPointAction = () => {
  return {
    type: REQUEST_UPDATE_CONTROL_POINT,
  };
};

const responseUpdateControlPointAction = (data) => {
  return {
    type: RESPONSE_UPDATE_CONTROL_POINT,
    data,
  };
};

const requestUpdateControlPointFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_CONTROL_POINT_FAILURE,
    errors,
  };
};

const updateControlPoint = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateControlPointAction());

    controlPointsService
      .updateControlPoint(options)
      .then((result) => {
        dispatch(responseUpdateControlPointAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateControlPointFailureAction(error.response));
      });
  };
};

export {
  REQUEST_CONTROL_POINTS,
  RESPONSE_CONTROL_POINTS,
  REQUEST_CONTROL_POINTS_FAILURE,
  getControlPoints,
  REQUEST_CREATE_CONTROL_POINT,
  RESPONSE_CREATE_CONTROL_POINT,
  REQUEST_CREATE_CONTROL_POINT_FAILURE,
  createControlPoint,
  REQUEST_DELETE_CONTROL_POINT,
  RESPONSE_DELETE_CONTROL_POINT,
  REQUEST_DELETE_CONTROL_POINT_FAILURE,
  deleteControlPoint,
  ON_SELECT_CONTROL_POINT,
  selectControlPoint,
  ON_UNSELECT_CONTROL_POINT,
  unselectControlPoint,
  REQUEST_UPDATE_CONTROL_POINT,
  RESPONSE_UPDATE_CONTROL_POINT,
  REQUEST_UPDATE_CONTROL_POINT_FAILURE,
  updateControlPoint,
};
